import React, { FC } from 'react';
import { PlayerColor } from '~/src/components/Game/types';

import { figureStyles, imageStyles } from './styles.css';

const getFigureImgSrc = ({
  setName,
  name,
  color,
  reverse,
}: {
  name: string;
  color: PlayerColor;
  reverse?: boolean;
  setName?: string;
}) => {
  const figureName = setName === 'king' ? `${name}${color}-${reverse ? 'b' : 'f'}` : `${name}${color}`;
  return `assets/sets-images/${setName || 'defaultC'}/${figureName}.png`;
};

type FigureProps = {
  name: string;
  color: PlayerColor;
  setName?: string;
  reverse?: boolean;
};

const Figure: FC<FigureProps> = ({ name, color, setName, reverse }) => (
  <div className={figureStyles}>
    <img src={getFigureImgSrc({ name, setName, color, reverse })} className={imageStyles} />
  </div>
);

export default Figure;
